import { push } from 'connected-react-router';
import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function getTicketById(id) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_TICKET_DETAIL_PAGE_REQUEST,
			payload: { loadingTicketDetail: true }
		});

		//Get all tickets
		const response = await API.ticket.getTicketById({ id });

		if(response.meta.code !== 200){
			dispatch({
				type: ActionTypes.GET_TICKET_DETAIL_PAGE_ERROR,
				payload: {
					meta: response.meta,
					loadingTicketDetail: false
				}
			});
			return;
		}

		const { ticket } = response.data;

		dispatch({
			type: ActionTypes.GET_TICKET_DETAIL_PAGE_SUCCESS,
			payload: {
				ticket,
				loadingTicketDetail: false
			}
		});
	};
}

export function getLaundryRooms() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_TICKET_DETAIL_LAUNDRY_ROOMS_REQUEST,
			payload: { loadingLaundryRooms: true }
		});

		//Get all tickets
		const response = await API.ticket.getLaundryRooms();

		if(response.meta.code !== 200){
			dispatch({
				type: ActionTypes.GET_TICKET_DETAIL_LAUNDRY_ROOMS_ERROR,
				payload: {
					meta: response.meta,
					loadingLaundryRooms: false
				}
			});
			return;
		}

		const { laundry_rooms } = response.data;

		dispatch({
			type: ActionTypes.GET_TICKET_DETAIL_LAUNDRY_ROOMS_SUCCESS,
			payload: {
				laundry_rooms,
				loadingLaundryRooms: false
			}
		});
	};
}

export function updateTicketLaundryRoomById({ laundry_room_id }) {
	return async (dispatch, getState) => {
		const { ticket } = getState().ticketDetailPageReducer;

		dispatch({
			type: ActionTypes.SUBMIT_TICKET_DETAIL_LAUNDRY_ROOM_REQUEST,
			payload: { loadingSubmit: true }
		});

		const body = {
			ticket: {
				laundry_room_id,
				updated_at: ticket.updated_at
			}
		};

		const response = await API.ticket.updateTicketLaundryRoomById(ticket._id, body);

		if(response.meta.code !== 200){
			dispatch({
				type: ActionTypes.SUBMIT_TICKET_DETAIL_LAUNDRY_ROOM_ERROR,
				payload: {
					meta: response.meta,
					loadingSubmit: false
				}
			});
			return;
		}

		const { ticket: newTicket } = response.data;

		dispatch({
			type: ActionTypes.SUBMIT_TICKET_DETAIL_LAUNDRY_ROOM_SUCCESS,
			payload: {
				ticket: newTicket,
				meta: response.meta,
				loadingSubmit: false
			}
		});
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_TICKET_DETAIL_PAGE_META
		});
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_TICKET_DETAIL_PAGE
		});
	};
}
